import React, { useState } from "react";
import style from "./styles.module.css";
import general from "../../css/General.module.css";

const Dialog = ({
  isOpen,
  title,
  options,
  actions = [],
  onClose,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  if (!isOpen) return null;

  // Render options depending on type
  const renderOptions = () => {
    if (!options) return null;

    // Case: array of objects
    if (Array.isArray(options)) {
      return options.map((item, index) => (
        <div
          key={index}
          className={`${style.item} ${selectedOption?.value === item.value ? style.selected : ""
            }`}
          onClick={() => setSelectedOption(item)}
        >
          <p>{item.value}</p>
        </div>
      ));
    }

    // Case: single object
    if (typeof options === "object") {
      return (
        <div
          className={`${style.row} ${selectedOption?.value === options.value ? style.selected : ""
            }`}
          onClick={() => setSelectedOption(options)}
        >
          <p>{options.value}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className={style.dialogView} onClick={onClose}>
      <div
        className={style.dialogContents}
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          {title && <div className={style.title}>{title}</div>}

          <div className={style.contents}>{renderOptions()}</div>

          {selectedOption != null ?
            <div className={[general.rowView, general.pd10px15px].join(" ")}>
              <div className={[general.fontSize17px, general.fontWgt500].join(" ")}>Price: ₹{selectedOption.final_price}</div>
              <div className={[general.colorLightBlack, general.fontSize14px, general.mgL10px].join(" ")}><s>₹{selectedOption.price}</s></div>
            </div>

            : null}

          {/* Action Buttons */}
          <div className={style.dialogControlView}>
            {actions.map((action, index) => (
              <button
                key={index}
                className={[
                  style.actionBtn,
                  action.variant === "positive"
                    ? style.positiveBtn
                    : style.negativeBtn,
                ].join(" ")}
                onClick={() => {
                  action.onClick?.(selectedOption);
                }}
                disabled={action.variant === "positive" && !selectedOption}
              >
                {action.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dialog;